import React, { type FC, useLayoutEffect } from "react";

import GLightbox from "glightbox";

const SCROLL_SMOOTH_CSS = `
  html {
    scroll-behavior: smooth;
    scroll-snap-type: y mandatory;
    scroll-padding: 150px;
  }
`;

const GLightBoxComponent: FC = () => {
  useLayoutEffect(() => {
    document
      .querySelectorAll("figure figure a")
      .forEach((anchor: HTMLAnchorElement) => {
        const href = anchor.getAttribute("href");

        const [_, hash] = href.split("#");

        if (hash) {
          const newAnchorUrl = `#${hash}`;

          anchor.setAttribute("href", newAnchorUrl);
          return;
        }
        if(href.match(/\.png|\.jpg|\.jpeg/g)?.length > 0) anchor.classList.add("glightbox");
      });

    GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
      zoomable: true,
    });
  });

  return <style dangerouslySetInnerHTML={{ __html: SCROLL_SMOOTH_CSS }} />;
};

export default GLightBoxComponent;
